import { create } from 'zustand';

type PublishedBoxType = '발행 리스트별' | '클래스 학생별' | '닉네임 별';

export interface PublishedBoxstateType {
    claIdList: { claId: string; claNm: string }[];
    setClaIdList: (newList: { claId: string; claNm: string }[]) => void;
    filterClassList: API.MyClassMemberList.ClassData[];
    setFilterClassList: (newList: API.MyClassMemberList.ClassData[]) => void;
    tab: string;
    setTab: (newTab: string) => void;
    searchPage: number;
    setSearchPage: (newPage: number) => void;
    searchKeyword: string;
    setSearchKeyword: (newKeyword: string) => void;
    searchUserId: string[];
    setSearchUserId: (newList: string[]) => void;
    selectClass?: {
        name: string;
        claId: string;
    };
    setSelectClass: (value: { name: string; claId: string } | undefined) => void;
    currentPublishedBoxTab: PublishedBoxType;
    resetData: () => void;
    checkKeyList: string[];
    setCheckKeyList: (newList: string[]) => void;
    claIdListData: { key: string; checked: boolean; claId: string[] }[];
    setClaIdListData: (newList: { key: string; checked: boolean; claId: string[] }[]) => void;
    publishType: number[];
    setPublishType: (newList: number[]) => void;
    publishState: number[];
    nickPublishState: number[];
    setPublishState: (newList: number[]) => void;
    setNickPublishState: (newList: number[]) => void;
    startDate: Date | undefined;
    setStartDate: (newDate: Date | undefined) => void;
    endDate: Date | undefined;
    setEndDate: (newDate: Date | undefined) => void;
    dateTab: string | undefined;
    setDateTab: (newTab: string | undefined) => void;
    setResetTab: () => void;
}

export const usePublishedBoxStore = create<PublishedBoxstateType>((set) => ({
    claIdList: [],
    setClaIdList: (newList: { claId: string; claNm: string }[]) => set({ claIdList: newList }),
    filterClassList: [],
    setFilterClassList: (newList: API.MyClassMemberList.ClassData[]) =>
        set({ filterClassList: newList }),
    tab: '발행 리스트별',
    setTab: (newTab: string) => set({ tab: newTab }),
    searchPage: 0,
    setSearchPage: (newPage: number) => set({ searchPage: newPage }),
    searchKeyword: '',
    setSearchKeyword: (newKeyword: string) => set({ searchKeyword: newKeyword }),
    searchUserId: [],
    setSearchUserId: (newList: string[]) => set({ searchUserId: newList }),
    setSelectClass: (value: { name: string; claId: string } | undefined) => {
        set({ selectClass: value });
    },
    currentPublishedBoxTab: '발행 리스트별',
    setSurrentPublishedBoxTab: (newTab: PublishedBoxType) =>
        set({ currentPublishedBoxTab: newTab }),
    resetData: () => {
        set({ searchPage: 0, searchKeyword: '' });
    },
    checkKeyList: [],
    setCheckKeyList: (newList: string[]) => set({ checkKeyList: newList }),
    claIdListData: [],
    setClaIdListData: (newList: { key: string; checked: boolean; claId: string[] }[]) =>
        set({ claIdListData: newList }),
    publishType: [1, 2, 3],
    setPublishType: (newList: number[]) => set({ publishType: newList }),
    publishState: [1, 2, 3],
    nickPublishState: [2, 3],
    setPublishState: (newList: number[]) => set({ publishState: newList }),
    setNickPublishState: (newList: number[]) => set({ nickPublishState: newList }),
    startDate: undefined,
    setStartDate: (newDate: Date | undefined) => set({ startDate: newDate }),
    endDate: undefined,
    setEndDate: (newDate: Date | undefined) => set({ endDate: newDate }),
    dateTab: undefined,
    setDateTab: (newTab: string | undefined) => set({ dateTab: newTab }),

    setResetTab: () =>
        set({
            publishState: [1, 2, 3],
            // startDate: undefined,
            // endDate: undefined,
            // dateTab: undefined,
            checkKeyList: [],
            claIdListData: [],
            publishType: [1, 2, 3],
            selectClass: undefined,
            searchPage: 0,
            searchKeyword: '',
            searchUserId: [],
            nickPublishState: [2, 3],
        }),
}));

export interface PublishedBoxstateDetailType {
    legacyTab: string | null;
    setLegacyTab: (newTab: string | null) => void;
    stntCnt: number;
    setStntCnt: (newStntCnt: number) => void;
    stntSubCnt: number;
    setStntSubCnt: (newStntCnt: number) => void;
}

export const usePublishedBoxDetailStore = create<PublishedBoxstateDetailType>((set, get) => ({
    legacyTab: null,
    setLegacyTab: (newTab: string | null) => {
        set({ legacyTab: newTab });
    },
    stntCnt: 0,
    setStntCnt: (newStntCnt: number) => {
        set({ stntCnt: newStntCnt });
    },
    stntSubCnt: 0,
    setStntSubCnt: (newStntCnt: number) => {
        set({ stntSubCnt: newStntCnt });
    },
}));
